import { GraduationCap } from "lucide-react";
import { EMAIL } from "../../data/content";

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-ink text-bone/50 border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex items-center gap-2.5">
                <GraduationCap className="w-4 h-4 text-bone/70" strokeWidth={1.75} />
                <span className="font-serif text-base text-bone">North Shore Scholars</span>
            </div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em]">
                Oliver Dean &amp; Ashton Fairbanks · UNSW Engineering · Knox Grammar 2025
            </p>
            <a
                href={`mailto:${EMAIL}`}
                data-testid="footer-email-link"
                className="font-mono text-[11px] tracking-wide hover:text-bone transition-colors duration-300"
            >
                {EMAIL}
            </a>
        </div>
    </footer>
);
